import React from 'react'
import './Ata.css'

const Ata = () => {
  return (
    <div className="ataPage">
      <div className="ataCard">
        <div className="ataBadge">Manutenção</div>
        <h1 className="ataTitle">Em breve</h1>
        <p className="ataText">
          A página de atas está em manutenção no momento. Em breve ela voltará disponível com acesso aos documentos e registros oficiais.
        </p>
      </div>
    </div>
  )
}

export default Ata